<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12">
            <h2>
                {{ pageTitle }}
            </h2>
        </v-col>
        <b-alert
            v-if="preview"
            type="info"
            message="Currently viewing user in preview mode."
            :has-header-button="can('api.v1.patients.update')"
            button-title="Edit user"
            :dismissible="false"
            @emitAction="$root.goTo($root.route('dms-users.get', { id: id }))"
        >
        </b-alert>
        <v-col cols="12">
            <dms-users-tabs></dms-users-tabs>
            <dms-users-tabs-items :preview="preview"></dms-users-tabs-items>
        </v-col>
    </div>
</template>

<script>
import BAlert from '../../../../../bgo/bgo-components/resources/js/components/BAlert.vue';

export default {
    components: { BAlert },
    props: {
        id: {
            type: String,
            default: null,
        },
        preview: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        pageTitle() {
            if (this.preview) {
                return t('dms-users::page.title.preview_dms_user');
            }
            return this.id ? t('dms-users::page.title.edit_dms_user') : t('dms-users::page.title.new_dms_user');
        },
        UserId() {
            return User && User.id ? User.id : false;
        },
    },
    created() {
        this.$store.dispatch('dms_users/setLoading', true);
        const sitesRequest = this.$store.dispatch('dms_users/loadPharmacySitesOptions');
        const groupsRequest = this.$store.dispatch('dms_users/loadPharmacyGroupsOptions');

        Promise.all([sitesRequest, groupsRequest]).then(() => {
            this.loadDmsUser();
        });
    },

    methods: {
        backToList() {
            return this.$root.goTo(route('dms-users.index'));
        },
        loadDmsUser() {
            this.$store.dispatch('dms_users/loadDmsUser', this.id).catch((error) => {
                this.$root.notify('error', error.message);
            });
        },
    },
};
</script>
